module.exports = __webpack_public_path__ + "img/pinjia4.997f2b30.jpg";